// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"breadcrumb_breadcrumb__32mBh","history":"breadcrumb_history__2LW0I","icon":"breadcrumb_icon__1ZEmO"};